import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import ClickToCopy from "components/shared/clipboardCopy/ClickToCopy";

import { getFirewallsDataset } from "redux/selectors/firewallSelector";

import UpdateFirewallName from "../actions/UpdateFirewallName";

const FirewallRecap = (): ReactElement => {
 const params = useParams<{ id: string; section: string }>();
 const firewallData = useSelector(getFirewallsDataset).find(
  (element) => element.id === Number(params.id)
 );

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2 }}>
   <Stack>
    <Typography
     fontWeight="bold"
     fontSize={16}
     variant="unboundedTitle"
     textAlign="left"
     textTransform="uppercase">
     {firewallData?.name || "N/A"}
    </Typography>
    <Stack direction={"row"} alignItems="center" mt={2} justifyContent="space-between" width="100%">
     <Stack>
      <Typography noWrap variant="subtitle1" fontWeight="bold">
       <FormattedMessage id="addons.firewall.name" />
      </Typography>
     </Stack>

     <Stack direction="row" alignItems="center">
      <ClickToCopy text={firewallData?.name || ""}>
       <Typography variant="subtitle2">{firewallData?.name || "N/A"}</Typography>
      </ClickToCopy>
      {firewallData && <UpdateFirewallName firewall={firewallData} />}
     </Stack>
    </Stack>
   </Stack>
  </Paper>
 );
};

export default FirewallRecap;
